<template>
  <div class="container mescroll-touch">
    <div class="goback">
      <img class="arrow-left" @click="$router.go(-1);" src="@/assets/images/arrow-left.png" />
      <span @click="$router.go(-1);">返回</span>
    </div>
    <p class="title">《用户协议》</p>
    <p>请仔细阅读本服务条款（以下简称本“协议”）。通过单击或轻按与本协议相关的“确定”或“同意”（或类似术语），或通过使用服务（如下定义），即表示您同意本协议的条款。我们建议您打印一份本协议以备将来参考。我们保留进行变更（如下所述）的权利。</p><br/>

    <p>本协议是您本人和强生（上海）医疗器材有限公司（以下简称“公司”或“我司”或“我们”或“我们的”）之间就您访问与使用术韵<strong>Medtech</strong>微信小程序与使用本协议或网站相关的移动软件应用程序、小程序或者H5页面（以下合称“应用程序”）（该等使用统称“服务”）而签订的协议。<strong>本协议中与您的权益（可能）存在重大关系的条款（包括免除公司责任的条款、限制您权利的条款、权利许可和信息使用条款、争议解决条款及司法管辖条款等），我们已采用字体加粗等方式来特别提醒您，请您留意重点查阅。请您确保您在使用服务前已仔细阅读、充分理解并毫无保留地接受本协议所有条款。</strong></p><br/>

    <p>如果您不愿意接受本协议的条款和条件，我们要求您请勿访问或使用服务、或在上面发布或提交任何资料、或从中订购任何项目。如需详细了解我们收集的信息以及我们如何使用所收集的个人信息，请查看我们的《隐私政策》。</p><br/>

    <p>本网站和应用程序针对并面向中国大陆医疗保健专业人士。如果您未满18周岁，请您不要使用网站或应用程序。</p><br/>

    <p>如果您代表您所关联的任何组织或为该等组织利益而使用服务，则您代表自己和该等组织同意本协议的条款，并确认您具有使该等组织受本协议约束的法律权限。本协议中提及的“您”和“您的”包括您和任何该等组织。</p><br/>

    <h3>1. 本应用程序功能和服务。</h3>
    <p>本应用程序包括以下功能和服务：提供学术支持信息和服务以及个性化互动服务，如向您提供直播预约和观看、学术视频内容、用户个人主页、活动推荐、活动通知、行业资讯、公司资讯、学术信息、学术调研、会议报道、研究进展、医学科学文献、短信提醒（包括但不限于活动开播提醒，内容更新提醒）等学术支持信息和服务，以及个性化互动服务。您仅能在本应用程序站内使用相应功能和服务。</p><br/>

    <h3>2. 我们进行变更的权利。</h3>
    <p>我们可能会（出于任何原因，如本网站或者应用程序提供的功能或服务发生变动、或为了反映法律的变化）不时变更本协议，但会以任何合理的方式通知您该等变更，并通过服务向您提供修订协议。任何该等变更将不适用于您和我们之间在我们发布包含该等变更的修订协议、或以其他方式通知您该等变更之前所发生的任何争议。您若单击或轻按与本协议相关的“确定”或“同意”（或类似术语）、或您在任何变更后对服务的使用，均将构成您对该等变更的接受。文首的“上次更新”图例标明了本协议最后一次变更的时间。</p><br/>
    <p>在适用法律允许的范围内，我们可自行决定随时变更或停止全部或部分服务（例如为了反映相关法律的变化、确保服务的安全性、或实施合理的技术调整和改进、修改网站或者应用程序提供的服务和功能） 且无需承担责任；在合理需要的情况下收取、修改或免除使用服务所需的任何费用；或向部分或所有用户提供机会。我们将力求以合理的方式通知您 (i) 任何将对您整体使用服务产生重大不利影响的变更；以及 (ii) 我们对使用服务所收费用的任何实质性增加。</p><br/>
    <p>您亦同意利用互联网信息技术以数据电文的形式订立本协议并完全认可其效力。</p><br/>

    <h3>3. 信息免责声明。</h3>
    <p style="font-weight: bold;">作为服务的一部分，网站或应用程序中提供的信息（包括任何建议和推荐）仅可用于教育和信息交流目的，而非针对任何个人问题提出的医疗或保健建议、或医疗诊断或治疗；也不是用来代替熟悉您自身独特事实且具备资质的医疗保健提供者所提供的专业建议和服务。您在网站或平台接触或获取的任何内容在任何情况下均不应被理解为对任何人士的任何专业诊疗意见，亦不应被理解为对任何医药产品或服务的推荐或用药指导。</p><br/>
    <p>对于您基于信息或作为服务一部分提供的其他资料而采取的任何作为或不作为而直接或间接造成的任何后果，我们不承担任何责任。虽然我们努力使服务所提供的信息保持准确、完整和最新，但对于作为服务一部分所提供的信息的准确性、完整性或及时性，我们不提供保证，也不对与此相关的任何损害或损失负责。</p><br/>
    
    <h3>4. 通过服务提交的信息。</h3>
    <p>您通过服务提交的信息受我们以及本协议下条款（包括尤其是“可接受的用途和行为准则”条款与“用户行为规范”条款）的规制。</p><br/>

    <h3>5. 司法管辖权问题。</h3>
    <p>服务可能在某些司法管辖区不适合使用或不可用。使用服务的任何风险均由您自行承担，且在承担风险时您须遵守相关法律、法规和条例。我们可出于正当原因（例如为了遵守相关法律和条例规定、保障服务的安全性、或实施合理的技术调整）随时将服务可用范围全部或部分的限制在我们自行选择的任何人员或地理区域内。</p><br/>
    
    <h3>6. 可接受的用途和行为准则。</h3>
    <p>您不得：</p>
    <ul class="ul">
      <li>在未经相关所有权人明确书面同意的前提下，通过服务或与服务相关而发布、传输或以其他方式提供任何资料，这些资料属于、或可能属于：(a) 威胁、骚扰、侮辱、仇恨、恐吓或以其他方式不尊重他人的权利和尊严；(b) 污蔑、诽谤或欺诈；(c) 隐晦、不雅、色情或以其他方式令人反感；或 (c) 受版权、商标、商业机密、发布权或隐私权、或任何其他专有权利的保护。 </li>
      <li>开展任何有可能危害公司或者我们关联方的网络安全的行为，包括但不限于：(a) 通过服务或与服务相关而发布、传输或以其他方式提供任何属于或可能属于有害、入侵、或旨在破坏或劫持任何硬件、软件或设备的操作，或旨在监视任何硬件、软件或设备使用的病毒、蠕虫、特洛伊木马、复活节彩蛋、定时炸弹、间谍软件或其他计算机代码、文件或程序（前述各项均简称“病毒”）；(b) 干扰服务的操作、或干扰用于提供服务的服务器或网络（包括通过黑客攻击或破坏服务的任何部分），或违反该等服务器或网络的任何要求或政策；(c)  试图获得未经授权访问公司的计算机网络或用户帐户；(d) 未经我们事先明确书面同意，将服务的任何部分合并到任何产品或服务中；(e) 系统下载和存储服务中涉及的内容、信息或者数据，或者基于服务中涉及的内容、信息或者数据与公司提供相同或者具有类似性质的服务；(f) 试图破坏、禁用、过载或损害公司的服务器或网络；(g) 未经允许进入公司网络或者系统并删除、修改、增加其中存储的数据或信息； (h) 修改或伪造相同系统运行中的指令、数据, ，增加、删减、变动相关系统的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；或 (i) 通过未经公司认可的第三方软件、插件、外挂、系统，登录或使用网站、应用程序及服务， 或制作、发布、传播上述工具。</li>
      <li>将服务用于任何商业目的，包括用于您的商业目的或将以任何方式使您受益的任何商业目的。</li>
      <li>将服务用于任何欺诈性目的或其他非法目的。</li>
      <li>采用任何方式（包括通过逆向工程）收集有关使用服务的用户的信息。</li>
      <li>限制或禁止任何他人使用服务。</li>
      <li>未经我们事先明确书面同意，擅自复制、修改、改编、翻译、创建衍生作品、出售、租赁、租借、分时共享、分发或以其他方式利用服务的任何部分（或任何使用），本协议明确授权的除外。</li>
      <li>对服务的任何部分进行逆向工程、反编译或反汇编，除非适用法律明确禁止对前述行为进行限制。</li>
      <li>从服务中删除任何版权、商标或其他专有权声明。</li>
      <li>未经我们事先明确书面同意，使用任何机器人（robot）、蜘蛛（spider）、站点搜索／检索应用程序或其他手动或自动设备来检索、索引、“抓取”、“数据挖掘”或以其他方式收集服务内容，或复制或绕过服务的导航结构或演示。我们允许公共搜索引擎运营商使用蜘蛛探测器从服务中复制资料，仅用于（且仅在必要时用于）创建该等资料的公开可搜索索引，但不得对该等资料缓存或存档。我们保留无论在一般情况还是特定情况下均可随时撤销该等许可的权利，且无需另行通知。</li>
      <li>会鼓励刑事犯罪或引起民事责任的行为。</li>
      <li>未能遵守可适用的第三方条款（统称为“可接受的使用”）。公司如认为是或可能违反可接受的使用条款或公司的政策的，可自行决定，保留终止您的用户许可、终止您参与内容或使用网站或应用程序的权利，但强生未能或延迟采取此类措施不构成放弃其执行此处条款的权利。</li>
    </ul>
    <p>当您使用服务时，您不得违反上述的任何条款，且您将自行负责获取、维护和支付您使用服务所需的所有硬件、电信和其他服务。</p><br/>

    <h3>7. 用户行为规范。</h3>
    <p>您在使用服务时必须遵守《网络安全法》《计算机信息网络国际联网安全保护管理办法》《互联网信息服务管理办法》《互联网用户账号信息管理规定》《网络信息内容生态治理规定》等中华人民共和国相关法律法规的规定。<strong>您知悉并同意将不会利用服务进行任何违法或不正当的活动，包括但不限于下列行为：</strong></p><br/>
    <p>(1)制作、复制、发布、上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：</p>
    <ul class="ul">
      <li>反对宪法所确定的基本原则的；</li>
      <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
      <li>损害国家荣誉和利益的；</li>
      <li>歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的;</li>
      <li>宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</li>
      <li>煽动民族仇恨、民族歧视、破坏民族团结的；</li>
      <li>破坏国家宗教政策，传教, 开展宗教教育培训、发布讲经讲道内容或者转发、链接相关内容，组织开展宗教活动以直播或者录播宗教仪式，成立宗教组织、设立宗教院校和宗教活动场所、发展教徒，以宗教名义开展募捐，宣扬邪教和封建迷信的；</li>
      <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
      <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
      <li>侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；</li>
      <li>含有虚假、诈骗、有害、胁迫、侵害他人个人信息、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</li>
      <li>含有可能涉及侵害国家主权和领土完整、违反国家关于地图绘制、发布相关规定的内容；</li>
      <li>使用夸张标题，内容与标题严重不符的；</li>
      <li>炒作绯闻、丑闻、劣迹等的；</li>
      <li>不当评述自然灾害、重大事故等灾难的；</li>
      <li>带有性暗示、性挑逗等易使人产生性联想的；</li>
      <li>展现血腥、惊悚、残忍等致人身心不适的；</li>
      <li>煽动人群歧视、地域歧视等的；</li>
      <li>宣扬低俗、庸俗、媚俗内容的；</li>
      <li>可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；</li>
      <li>其他对网络生态造成不良影响的内容；</li>
      <li>宣传、推广任何药品、医疗器械、保健品、医疗服务（包括任何关于药品、医疗器械、保健品、医疗服务的功效、安全、质量或其他方面的保证、断言或其他不具有客观实证依据的主观判断或偏向性意见，或涉及不同药品、医疗器械、保健品的功效比较）；</li>
      <li>含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。</li>
    </ul><br/>
    <p>(2)利用网站或者移动应用程序从事任何违反本协议第5. 条下可接受的用途和行为准则的行为；</p><br/>
    <p>(3)您不得利用基于深度学习、虚拟现实、生成式人工智能等新技术新应用制作、上传、复制、传送、传播虚假新闻信息等法律法规禁止的信息内容，或将合成内容谎称为自然内容。您在发布或传播利用基于深度学习、虚拟现实、生成式人工智能等新技术新应用制作的非真实文图、图片、音视频信息时，应当以显著方式予以标识。</p><br/>
    
    <h3>8. 产品（如适用）。</h3>
    <p>服务可能提供商品或服务（以下统称“产品”）的清单、描述和图像，以及产品的参数和链接。我们试图尽可能准确地描述服务中提供的项目，并描述可获得的最新产品包装。对于该等清单、描述或图像（包括其中包含的任何功能、规格和价格）的完整性、准确性、可靠性、有效性或及时性，我们不作任何保证或声明，也不保证所描述的产品包装与您收到的实际产品相匹配。该等信息和任何产品的可用性可随时变更，无需另行通知。</p><br/>
    
    <h3>9. 电子通信。</h3>
    <p>作为服务的一部分进行通信的信息可能构成电子通信。当您通过服务或其他形式的电子媒体（如电子邮件）与我们通信时，您是以电子方式与我们通信。您同意，我们可以在遵守当地隐私法和反垃圾邮件法律的情况下进行电子通信，并且该等通信以及我们以电子方式向您提供的通知、披露、协议和其他通信，均等同于书面通信，并具有与通信发送方签署的书面通信相同的效力。</p><br/>
    
    <h3>10. 账号注册与管理。</h3>
    <p>您可能需要注册才能使用全部或者部分服务。</p>
    <p>本网站和应用程序针对并面向中国大陆医疗卫生专业人士以及公司员工开放使用。</p><br/>
    <p><strong>民事行为能力：</strong>您确认您具备完全民事权利能力和完全民事行为能力，有能力同意并遵守本协议，并对您本协议项下的全部行为独立承担法律责任。您完成注册程序或以其他我们同意的方式实际使用服务时，即视为您确认自己具备主体资格，能够独立承担法律责任。</p><br/>
    <p><strong>实名制要求：</strong>在适用法律要求的情况下，我们会依据相关的法律要求您提供您的真实身份信息进行实名注册，并对您提供的身份信息进行认证。<strong>您在此同意并授权，我们可以基于您提供的真实身份信息（包括但不限于手机号码等）向全国公民身份号码查询服务中心及其授权的合作伙伴、电信运营商、金融服务机构发起身份真实性查询。</strong></p><br/>
    <p><strong>账号注册与管理：</strong>我们在网站和应用程序上提供账号的注册通道。当您是我们的员工时，您还可以通过公司内部账号体系登录网站或应用程序。应保证所使用的第三方软件或平台的用户账号已完成真实身份信息认证，并符合相关法律法规要求。您应保证所使用的第三方软件或平台的用户账号已完成真实身份信息认证，并符合相关法律法规要求。除非法律法规另有规定，<strong>就您在网站或应用程序中注册的账号的所有权以及有关权益均归公司所有，但您在注册完成之后享有该账号的使用权。</strong>在任何情况下，您的账号、用户名和密码将作为登录凭证，仅供您个人使用。除非公司同意，您不得以任何形式赠与、借用、出租、转让、售卖、抵押、继承您在网站或应用程序下的账号，或者以其他方式许可您之外的其他人员使用您的账号。<strong>对于在您的账号下发生的所有活动，无论是否知情，对您均产生约束力且您均应承担全部责任。</strong>您同意，您为注册账号目的向我们提供的任何信息（包括您的个人信息）都是准确完整的最新信息，如发生任何变更（例如更换了手机号），您将通知我们，从而确保该等信息始终为最新信息。</p><br/>
    <p><strong>账号命名与使用：</strong>您注册的账号、用户名以及其他网络身份标识信息（如昵称、头像及简介）的命名及使用，应遵守相关法律法规并符合网络道德：(a) 申请注册的账号、用户名以及其他网络身份标识信息，不得含有违法信息或者任何侮辱、诽谤、淫秽或暴力等侵害他人合法权益或违反公序良俗的不良信息；(b) 不得冒充他人或恶意注册或者使用账号使人误认（例如假冒、仿冒他人姓名、名称、字号、商标、头像等作为账号信息）；(c) 不得利用他人的名义发布任何信息。<strong>如您违反前述规定，我们有权随时拒绝您的账号注册清册、限制或拒绝您使用该账号，甚至注销该账号。</strong>我们可能会拒绝或要求您更改您提供的任何用户名、密码或其他信息。您应全权负责维护您的账号信息、账号密码以及其他与账号相关的信息、资料的机密性，并负责对您的移动设备、计算机的访问和／或其他访问服务方式进行限制。对于由于您未能对您的证件进行保密而导致的任何使用，我们概不负责。对于您知晓的、任何未经授权擅自使用您的证件或账号的情况，您必须立即通知我们。我们建议您在通过移动设备访问服务时，对该设备进行密码保护。</p><br/>
    <p><strong>账号注销：您可以依照我们的流程申请注销您的账号，但您仍应对您在注销账号前和使用网站或应用程序期间的行为承担相应责任。注销成功后，除非法律法规另有规定，我们不会为您提供账号记录、内容或虚拟财产恢复等服务，请您谨慎操作。</strong></p><br/>
    <p><strong>账号违规处置：</strong>我们保留可随时决定暂停或终止向您提供服务，冻结、终止或者中止您使用账号的权利，原因包括但不限于：(a)对适用法律法规或者本协议的违反；(b) 我们有理由怀疑您提供的注册信息为不合法、不真实、不准确、不详尽的资料，或者提供的注册信息中含有违法内容；(c) 存在任何形式的账号欺诈或滥用的情形；或者(d)您或使用您的账号的任何人可能向我们作出的任何失实陈述。</p><br/>
    
    <h3>11. 个人资料和论坛。</h3>
    <p>您可能被允许提供与服务相关（包括个人资料页面或互动功能）的某些信息或资料（每一份信息或资料的提供以下均简称“提交内容”）。我们对任何提交内容、任何第三方对提交内容的任何使用或误用、或您与其他用户的互动，均没有控制权，也不承担任何责任。用户最终应对自己的行为负责。如果您选择通过服务公开您的个人或其他信息，您将自行承担相关风险，并应确保不侵犯第三方权利。</p><br/>
    <p>您承认，任何论坛都包含其他用户的意见和观点。您进一步承认，我们不对网站或者应用程序上的任何提交内容的准确性负责。您理解并同意，提交者应对所有的提交内容全权负责。您理解并同意，您将对任何提交内容的使用（包括对该等提交的准确性、完整性或有用性的任何依赖）进行评估，并承担与之相关的所有风险。</p><br/>
    <p>在不影响前述规定的前提下，根据适用的法律和法规，我们可以根据本协议第12. 条规定监控您对服务的使用情况。</p><br/>

    <h3>12. 我们使用提交内容的权利。</h3>
    <p>本协议中的任何内容都不会转让您对提交内容的任何所有权。对于每一份提交内容，您均授予我们一项全球范围、免版税、已付讫、非独占、永久的、不可撤销、可转让和可完全再许可（通过多层许可的方式）的许可证，使我们可以采用现在已知或以后开发的任何格式或媒体复制、分发、执行和（公开或以其他方式）显示、创建衍生作品、改编、修改、存储和以其他方式使用、分析和利用该等提交内容，并就您的提交内容联系您，用于任何目的（包括推广目的，如推荐和广告），而无需对您或任何第三方支付额外对价。</p><br/>
    <p><strong>我们可以自由使用任何提交内容中包含的、或衍生的任何想法、概念、技术诀窍或技术，用于任何目的，包括开发、制造和营销产品。因此，请勿向我们提交或发送任何您希望保密或希望对此获得赔偿的想法、建议或资料。您不会就提交内容的任何使用或不使用对我们提出任何索赔。</strong>在提交内容时，您理解，在适用法律和我们的《隐私政策》允许的范围内，我们有权（但无义务）在世界各地的服务中以及我们或我们的关联公司拥有或运营的任何关联或继任网站、应用程序或社交媒体渠道上，永久性的使用、显示和发布您的姓名、照片、肖像、声音、表演、履历信息和／或声明。如果我们使用这些权利中的任何一项，您理解并同意，您不会收到任何其他对价、付款、通知或信用，也不对我们如何使用这些权利拥有任何批准权。</p><br/>
    <p>此外，如果您向我们提供任何想法、提议或建议（以下简称“反馈”），我们将视该等反馈为提交内容。您同意，反馈不属于机密性质，您对反馈的提供为免费、非应邀行为且不设任何限制，不会使我们就该等反馈承担任何义务。</p><br/>
    <p>您确认 (a) 您拥有授予本条规定中授予许可证所需的所有权利，(b) 您的提交内容完整准确，以及 (c) 您的提交内容和您向我们提交的行为没有欺诈或以任何方式违反任何适用法律或任何第三方的任何权利。您进一步不可撤销地放弃根据任何适用法律、您对提交内容可能拥有的对资料著作权或完整性归属的任何“精神权利”或其他权利（并同意我们对于可能不符合前述权利的提交内容及其相关资料可进行任何作为或不作为）。</p><br/>
    <p>我们可能会对服务的提交内容的存储空间设置最大容量。对于为了维持最大存储容量而对任何消息、通信或其他提交内容所作的任何删除或未能保存并因此可能使您遭受的任何损失或损害，我们概不负责。</p><br/>
    
    <h3>13. 监控服务的使用情况。</h3>
    <p>我们有权对您使用网站或者应用程序以及服务的情况进行审核监督（包括在提交内容出现在服务之前或之后对提交内容进行监控、评估、更改或删除，或分析您对服务的访问或使用情况）。<strong>如果我们认为您在使用网站或者应用程序以及服务时违反适用法律法规或者本协议的任何约定，我们可以基于独立判断采取相应的技术措施例如删除、屏蔽、断开链接，而无需任何提前通知。基于您的行为性质，我们还可以采取包括但不限于终止或中止服务，冻结、终止或中止您账号使用，追究相关法律责任等措施。如果我们发现或者收到他人举报或投诉您违反本协议约定的，我们有权独立判断并视情况采取限制账号部分或者全部功能直至终止提供服务、永久关闭账号等措施，对于因此而造成您无法正常使用账号及网站、应用程序或者服务等后果，我们将不承担任何责任。对涉嫌违反法律法规、涉嫌违法犯罪的行为，我们将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安机关报案等。</strong></p><br/>
    <p>我们可能会披露有关您访问和使用服务的信息、提交内容的传输情况，以及关于提供提交内容的用户的个人信息，但前述每种情况均须根据适用法律、或法院或执法部门或其他政府机构的请求、或根据我们的《隐私政策》才可进行披露。</p><br/>
    
    <h3>14. 您使用服务的权利。</h3>
    <p>您承认，服务（包括网站和应用程序）中的所有知识产权均属于我们或我们的许可人。除根据本协议访问服务的权利外，您不拥有服务所含或所赋予的其他权利。在遵守本协议的前提下，仅在本协议有效期内：(a) 您可以在任何一台设备上浏览网站的一份副本，仅用于您个人的非商业用途；(b) 我们允许您在有限的、非独占、可撤销、不可转让、不可再许可的基础上，在您拥有或控制的设备上安装和使用应用程序，仅用于您个人的非商业用途。应用程序为许可（而非出售）给您使用。如果您未遵守本协议，您必须立即停止使用服务，并从您的设备中删除应用程序。您有责任确保您的设备安全并对其进行适当的保护。</p><br/>

    <h3>15. 公司的专有权利。</h3>
    <p>我们和我们的供应商是服务的所有权人，这些服务受专有权和法律的保护，包括我们的所有品牌名称、商标和服务标记以及任何相关标识。非我们所有的、服务中的所有商品名称、商标、服务标记和标识（以下统称“商标”）均为其各自所有权人的财产。您不得在不属于我们的任何产品或服务中使用我们的商标，或以任何可能引起混淆的方式使用我们的商标。未经所有权人事先明确书面同意，服务中包含的任何内容都不应被诠释为授予了使用任何商标的任何权利。</p><br/>
    
    <h3>16. 第三方资料；链接。</h3>
    <p>服务可能允许对第三方信息、产品、服务和其他资料，包括提交内容（以下统称“第三方资料”）进行访问，并包括通过链接进行的任何访问。我们不控制或背书任何第三方资料、也不对任何第三方资料负责。我们没有义务监控第三方资料，但我们可以随时阻止或禁止对任何第三方资料的访问。您对第三方资料的访问或使用由您自行承担风险，且受适用该等资料的任何附加条款、条件和政策的规制。</p><br/>
    
    <h3>17. 附加条款。</h3>
    <p>附加条款可能对服务的某些特定功能或内容，例如优惠、抽奖、竞赛和抓彩进行规制。通过参与作为服务的一部分且受附加条款规制的任何活动，如抽奖、比赛、竞赛或带有官方规则的抓彩，您同意除本协议外，您还将遵守这些附加条款的规定。</p><br/>

    <h3>18. 担保免责声明。</h3>
    <p>在适用法律允许的最大范围内，服务均按“原样”、“原地”和“现有”的方式向您提供，不提供任何形式的担保或条件，无论是明示、默示还是法定。</p><br/>
    <p>我们在适用法律允许的最大限度内对服务不作任何保证，包括对于适销性、特定目的的适用性、非侵权和所有权的保证。</p><br/>
    <p>在适用法律允许的最大范围内，并在遵守第15. 条规定的、适用于使用第三方资料的任何适用条款和条件或政策的前提下，第三方资料均按“原样”、“原地”和“现有”的方式向您提供，而不提供任何形式的担保，无论是明示还是默示。我们不对第三方资料作任何保证。</p><br/>
    <p>在不限制前述条款通用性的前提下，在适用法律允许的最大范围内，我们不对以下各项作任何声明或保证：服务的安全性；您针对服务可能使用或允许他人使用的任何用户名、密码或其他安全措施可防止未经授权擅自访问您的服务账号或相关信息；或者您的服务账号或相关信息不会被任何第三方访问或误用。</p><br/>
    <p>本协议（包括本条规定和本协议其他条款）中任何形式的免责声明均出于公司及其关联公司、及其各自股东、董事、高级管理人员、员工、关联公司、代理、代表、许可人、供应商和服务供应商及其各自的继任和受让人（以下统称“公司各方”）的利益而制定。</p><br/>
    <p>尽管我们采取合理步骤尽力维护服务的及时性、完整性和安全性，但我们不能保证服务现在或将来始终是最新的、完整的、正确的或安全的，或者对服务的访问不会发生中断。服务可能包括与本协议冲突的不准确之处、错误和资料。此外，第三方可能对服务进行未经授权的更改。如果您知悉任何该等更改，请使用“联系我们”［链接］的链接，并提供该等更改的描述及其在服务中的位置。</p><br/>

    <h3>19. 责任限制。</h3>
    <p>本协议中的任何内容均不限制、排除或修改或意在限制、排除或修改根据适用法律强制规定的任何消费者法定权利。</p><br/>
    <p>对于根据适用法规不能被排除的任何条件、保证或担保，在适用法律允许的范围内，我们的责任仅限于（根据我们的选择）重新提供相关部分的服务或退还相关部分服务的费用。</p><br/>
    <p>在适用法律允许的最大范围内：(A) 根据任何合同、侵权（包括疏忽）、严格责任或其他理论，我们不对任何类型的间接性、偶然性、后果性、特殊性、示例性或惩罚性损害赔偿，或在您同意本协议时、您或我们均无法合理预见的损失（在每种情况下均因服务或本协议引起或与此相关）（以下统称“间接损失”）承担责任。如果损失或损害显然会发生，或在签订合同时、您和我们都知道可能会发生，则属于可预见的损失或损害。</p><br/>
    <p>在不限制前述规定的情况下，对于您使用或不能使用服务、或由于任何产品或第三方资料（包括与此相关原因可能传播的任何病毒）而造成的任何形式的间接损失，我们将不承担任何责任。</p><br/>
    <p>公司各方不会在不合法的情况下，以任何方式排除或限制我们对您的责任。这包括因我们的疏忽或我们的员工、代理或分包商的疏忽，重大疏忽或故意行为，欺诈行为或欺诈性失实陈述而导致的死亡或人身伤害的责任。</p><br/>
    <p>我们对于由服务或本协议引起、或与之相关的所有损害、损失和诉讼原因的最大累计责任，无论是在合同、侵权（包括疏忽）还是其他方面，都不超过 (a) 您为使用服务向我们支付的总金额（如有）；</p><br/>
    <p>本协议（包括本条规定和本协议其他条款）中任何形式的责任限制均出于公司和公司各方的利益而制定。</p><br/>
    <p>对于根据法规不能被排除的任何条件、保证或担保，在适用法律允许的范围内，我们的责任仅限于（根据我们的选择）重新提供相关服务或退还相关服务的费用。</p><br/>
    <p><strong>您知悉并同意，在网站或应用程序上公开发布或私下传输的任何信息或内容均由该内容的来源者承担全部责任，您访问所有此类信息和内容的风险由您自行承担，我们无法控制也没有义务就您如何理解和使用内容，或您因接触内容而可能采取的行动，而采取措施。</strong></p><br/>

    <h3>20. 第三方索赔。</h3>
    <p>如果您因违反本协议或侵犯任何第三方权利而被第三方起诉，则在适用法律允许的最大范围内，您将对公司各方产生的所有责任、损害赔偿、判决、裁决、损失、成本、开支和费用（包括律师费）负责。</p><br/>

    <h3>21. 终止。</h3>
    <p>您可以随时停止使用服务，从而终止本协议。如果您不遵守本协议、从事任何欺诈或滥用行为，或者如果您或您的帐户的任何使用人向我们作出任何失实陈述，我们可以终止或暂停您对服务的使用。在合理的情况下，我们将至少提前二十四（24）小时将服务的终止或暂停通知您，但是如果我们合理相信您已实质上违反了本协议，我们可立即终止或暂停您对服务的使用。一经终止或暂停，您使用服务的权利将立即停止，并且我们可以立即停用或删除您的用户名、密码和帐户以及所有相关资料，而无需对您或任何第三方承担责任，也无义务提供进一步访问该等资料的权限。您于本协议项下的义务应在本协议期满或终止后继续有效。</p><br/>
    
    <h3>22. 适用法律；司法管辖权。</h3>
    <p>除非适用法律另有规定，否则本协议受中国法律管辖并应根据中国法律进行诠释，无需考虑其法律冲突原则，也无需考虑您所在的位置。您和我们之间因服务或本协议引起的、或与之相关的所有争议，无论是基于合同、侵权、法规、欺诈、失实陈述或任何其他法律理论，包括非合同争议或索赔，都应服从公司住所所在地法院的专属管辖，并且您放弃任何因司法、审判地或法院地点不便而引致的异议。</p><br/>

    <h3>23. 过滤（如适用）。</h3>
    <p>家长监控保护措施（如计算机硬件、软件或过滤服务）可通过商业途径获取，帮助您限制访问可能对未成年人有害或不合适的资料。可通过<a href="https://en.wikipedia.org/wiki/Comparison_of_Content-Control_Software_and_Providers">https://en.wikipedia.org/wiki/Comparison_of_Content-Control_Software_and_Providers</a>获取识别当前该等保护措施提供商（我们对此不背书）的信息。</p><br/>

    <h3>24. 信息或投诉。</h3>
    <p>如果您对服务有任何疑问或投诉，包括了解到我们网站或者应用程序的安全缺陷或漏洞、任何用户存在违反本协议和适用法律法规的情况，请使用“联系我们”功能立即与我们取得联系。我们将及时处理您的投诉、举报信息，履行营造良好网络空间生态的法律责任。</p><br/>

    <h3>25. 版权侵权索赔。</h3>
    <p>如果您诚信地认为服务中提供的资料侵犯了您的版权，您可以通过邮件给我们写信，要求我们删除该等资料或阻止对该等资料的访问。请准确说明涉嫌侵权资料的特性和位置。如果您诚信地认为有人错误地针对您提交了侵犯版权的通知，您可以向我们发送书面异议通知。通知和异议通知必须通过“联系我们” 功能。在美国，除了可以通过单击“联系我们”功能联系我们外，还可以通过以下地址以书面形式联系公司与《数码千禧年版权法令》（DMCA）相关的投诉代理：</p><br/>
    <p>商标法部门</p>
    <p>强生集团</p>
    <p>One Johnson & Johnson Plaza</p>
    <p>新泽西州 新不伦瑞克</p>
    <p>邮编08933</p><br/>

    <p>此地址也可用于就美国以外司法管辖区的版权侵权索赔与我们联系，或者您可以通过 “联系我们”功能与我们联系。</p><br/>

    <h3>26. 出口管制。</h3>
    <p>服务受美国出口管制限制。我们不会有意向您提供服务，如果您是、并确认自己是 (a) 身处任何受美国政府禁运或贸易制裁的国家（目前为古巴、伊朗、苏丹、叙利亚和乌克兰的克里米亚地区）（有关美国制裁的更多信息，请参见<a style="overflow-wrap: break-word;word-break: break-all;" href="http://www.Treasuryury.gov/resource-center/Increments/Programs/Pages/Programs.aspx">http://www.Treasuryury.gov/resource-center/Increments/Programs/Pages/Programs.aspx</a>），或其居民或国民；或 (b) 列于美国政府的任何受限制最终用户名单上（例如，包括可在<a style="overflow-wrap: break-word;word-break: break-all;" href="http://www.Treasuryury.gov/resource-center/unescription/sdn-list/pages/default.aspx">http://www.Treasuryury.gov/resource-center/unescription/sdn-list/pages/default.aspx</a>获取的“特别指定国民”名单）。</p><br/>

    <h3>27. 前瞻性表述。</h3>
    <p>出现在服务中涉及我们、我们的关联公司或我们及其关联公司管理层且不属于历史事实的表述均属于“前瞻性表述”。前瞻性表述纯属预测，未来的实际事件可能与任何前瞻性表述中讨论的事件有实质性差异。各种外部因素和风险影响我们的运营、市场、产品、服务和价格。这些因素和风险在我们向美国证券交易委员会（SEC）提交的当前年度报告中以及我们向SEC提交的其他文件中已作描述。您可以通过位于www.sec.gov的SEC EDGAR系统查阅我们最新的SEC文件，也可以直接从我司免费获取这些文件。对于任何前瞻性表述或出现在服务中的任何其他陈述，我们不承担任何更新、修改或补充的义务或责任。</p><br/>

    <h3>28. 其他重要条款。</h3>
    <p>本协议不会、也不应解释为在您和我们之间创建了任何合伙、合资、雇主与雇员、代理、或特许人与被特许人的关系。本协议是您和我们之间签订的协议。除第18、19和28条规定外，其他任何人均无权执行本协议的任何条款。如果本协议的任何条款被判定为非法、无效、或由于任何原因无法执行，则该条款将视为可从本协议分离，并且不会影响任何剩余条款的有效性和可执行性。未经我们事先书面同意，您不得出让、转让或再许可您于本协议项下的任何或所有权利或义务。我们可以不受限制地出让、转让或再许可我们于本协议下的任何或所有权利或义务。任何一方对本协议项下任何违约或不履行的弃权均不得被认为是对之前或随后的任何违约或不履行的弃权。本协议中包含的任何标题、说明或章节标题仅为方便起见，在任何情况下均不构成对任何章节或条款的定义或解释。在适当的情况下，除非另有说明，否则所有单数定义的术语在使用复数时应具有相同的含义。在本协议中，术语“包括”或其变体的任何用法应被解释为后接短语“但不限于”。本协议（包括本协议中包含的任何条款和条件）是您和我们之间关于本协议主题事宜的完整协议，并且在没有欺诈成分的情况下，取代您和我们之间关于该主题事宜的任何及所有先前或同期作出的书面或口头协议或谅解。向您发出的通知（包括本协议的变更通知）可通过在服务中发布或通过电子邮件（在每次通知时均包括通过链接）或普通邮件发出。但不限于，本协议和任何以电子形式发出的通知的打印版本，应在基于或与本协议相关的司法或行政诉讼中予以受理，其受理范围和条件应与最初以打印形式生成和维护的其他商业文件和记录相同。任何一方均不对因其无法控制的任何原因而未能履行任何义务的行为承担责任。</p><br/>

    <h3>29. 苹果要求的条款。</h3>
    <p>除同意上述条款和条件外，即使本文有任何相反的规定，以下条款也适用于您使用与Apple Inc.（以下简称“苹果”）iOS操作系统兼容的任何版本的应用程序。苹果不是本协议的协议方，不拥有、也不对应用程序负责。苹果不为应用程序提供任何担保，除非在适用的情况下，将退还其购买价格。苹果不负责应用程序的维护或其他支持服务，也不会对与应用程序有关的任何其他索赔、损失、债务、损害赔偿、成本或支出负责，包括任何第三方产品责任索赔、对于苹果未能遵守任何适用法律或监管要求的索赔、根据消费者保护、隐私或类似法律引起的索赔（包括与使用苹果的HealthKit或HomeKit框架应用程序相关的索赔），以及与知识产权侵权有关的索赔。与使用应用程序有关的任何查询或投诉，包括与知识产权有关的查询或投诉，必须按照上述“信息或投诉”章节规定向公司提出。本协议中授予您的许可仅限于不可转让的许可，以便您在运行苹果iOS操作系统、并由您拥有或控制的苹果品牌产品上使用应用程序，或根据苹果应用商店（App Store）服务条款中规定的使用规则使用应用程序，但与购买者关联的其他帐户可能通过家庭共享或批量购买访问和使用应用程序的情形除外。此外，在使用应用程序时，您必须遵守适用于您的任何第三方协议的条款，例如您的无线数据服务协议。苹果和苹果的子公司是本协议的第三方受益人，在您接受本协议的条款和条件后，将有权（并视为已接受该权利）作为第三方受益人对您执行本协议；尽管有前述规定，公司根据本协议订立、撤销或终止任何变更、放弃或和解的权利不需要任何第三方的同意。</p><br/>
    
    <h3>30. 开放源码的字体许可语言 —— 如适用，字体版权信息：</h3>
    <p>［阿里妈妈数黑体］字体版权©［2023］，［阿里妈妈·智造字］。本字体软件根据［阿里妈妈数黑体免费商用许可］字体许可证，版本［1.0］得到许可。本许可证副本如下：</p><br/>
    <p>阿里妈妈数黑体法律声明</p><br/>
    <p>1.阿里妈妈数黑体字体及包含该字体的字库软件，合称“阿里妈妈数黑体”。</p><br/>
    <p>2.阿里妈妈数黑体的知识产权和相关权益归属于淘宝（中国）软件有限公司（以下简称“阿里妈妈”），受《中华人民共和国著作权法》及其他适用法律法规、国际公约、条约的保护。</p><br/>
    <p>3.阿里妈妈授权个人、企业等用户在遵守本声明相关条款的前提下，可以下载、安装和使用上述阿里妈妈字体，该授权是免费的普通许可，用户可基于合法目的用于商业用途或非商业用途，但不得以任何违反本声明第4条及法律法规、政策、规章或公序良俗的方式使用。</p><br/>
    <p>4.除本法律声明中明确授权之外，阿里妈妈未授予用户关于阿里妈妈数黑体的其他权利。未经阿里妈妈授权，任何人不得：1）对阿里妈妈数黑体进行仿制、转换、翻译、反编译、反向工程、拆分、破解或以其他方式试图从该字库软件获取源代码；2）删除、覆盖或修改阿里妈妈数黑体法律声明的全部或部分内容；3）将阿里妈妈数黑体进行单独定价出售、出租、出借、转让、转授权、或采取其他未经阿里妈妈授权的行为；4) 发布任何使外界误认其与阿里妈妈或其关联公司存在合作、赞助或背书等商业关联的不实信息。</p><br/>
    <p>5.阿里妈妈授予用户的上述授权不附带任何明示或暗示的保证，不对任何人因从非阿里妈妈官方渠道或指定渠道下载、安装或使用阿里妈妈数黑体而引发的任何直接或间接损失承担责任。</p><br/>
    <p>6.本声明的解释、履行与争议解决适用中华人民共和国的法律。用户与阿里妈妈就阿里妈妈数黑体的使用若发生争议，双方应友好协商，若协商不成，任一方有权向浙江省杭州市有管辖权的人民法院提起诉讼。</p><br/>
    <p>© 除非另有说明，否则附上 ©［</p>
    <p><strong>版权方： </strong>淘宝（中国）软件有限公司</p>
    <p><strong>设计者/贡献者： </strong>阿里妈妈·智造字</p>
    <p>］2019。版权所有。</p><br/>

    <p style="text-align: right;">【2026年7月31日】</p><br/>

    <p style="text-align: right;"><span>签署人：{{ user_name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>签署时间：{{ user_clause_time }}</span></p>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  data() {
    return {
      user_name: '',
      user_clause_time: ''
    }
  },
  created() {
    let userInfo = sessionStorage.getItem("userInfo");
    if(userInfo) {
      this.user_name = JSON.parse(userInfo).UserName;
      let user_clause_time = JSON.parse(userInfo).user_clause_time;
      if(user_clause_time) {
        this.user_clause_time = user_clause_time.includes('T') ? user_clause_time.replace('T', ' ') : user_clause_time;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  font-size: 12px;
  padding: 12px;
  box-sizing: border-box;
  background-color: #F8F8F8;
  padding-bottom: 50px;
  .goback {
    display: flex;
    align-items: center;
    font-size: 14px;
    .arrow-left {
      display: block;
      width: 18px;
      margin-right: 2px;
    }
  }
  .title {
    font-size: 15px;
    text-align: center;
    font-weight: bold;
  }
  .subtitle {
    font-size: 14px;
    font-weight: bold;
  }
  p {
    line-height: 2;
  }
  .ul {
    list-style-type: disc;
    margin-left: 30px;
    li {
      line-height: 2;
    }
  }
  .child_ul {
    list-style-type: circle;
    margin-left: 14px;
    li {
      line-height: 2;
    }
  }
  a {
    color: #1989fa;
  }
  .table1 {
    border: 1px solid #000000;
    .tr {
      display: flex;
      .td { 
        padding: 8px 5px;
      }
      .td1 {
        width: 33.33%;
        border-right: 1px solid #000000;
      }
      .td2 {
        width: 33.33%;
        border-right: 1px solid #000000;
      }
      .td3 {
        width: 33.33%;
      }
    }
    .tr:not(:last-of-type) {
      border-bottom: 1px solid #000000;
    }
    .tr:first-of-type {
      background-color: #dddddd;
    }
  }
  .table2 {
    border: 1px solid #000000;
    .tr {
      display: flex;
      .td { 
        padding: 8px 5px;
      }
      .td1 {
        width: 15%;
        border-right: 1px solid #000000;
      }
      .td2 {
        width: 20%;
        border-right: 1px solid #000000;
      }
      .td3 {
        width: 20%;
        border-right: 1px solid #000000;
      }
      .td4 {
        width: 15%;
        border-right: 1px solid #000000;
      }
      .td5 {
        width: 30%;
      }
    }
    .tr:not(:last-of-type) {
      border-bottom: 1px solid #000000;
    }
    .tr:first-of-type {
      background-color: #dddddd;
    }
  }
}
.ul {
    list-style-type: disc;
    margin-left: 30px;
    li {
      line-height: 2;
    }
}
</style>